import { type GetHookResponse } from '../../hooks'
import { interviewQuestionKey } from '../../keys'
import { useTantalimQuery } from '../../query'
import {
  type InterviewQuestionData,
  type InterviewQuestionGetInput,
  type InterviewQuestionGetSuccess,
  type InterviewQuestionId,
  Logger,
} from '@terros/common'

const logger = new Logger('useInterviewQuestion')

export function useInterviewQuestion(interviewQuestionId: InterviewQuestionId): GetHookResponse<InterviewQuestionData> {
  logger.verbose('calling useInterviewQuestion', interviewQuestionId)
  return useTantalimQuery<InterviewQuestionGetInput, InterviewQuestionGetSuccess, InterviewQuestionData>({
    url: '/interview/question/get',
    queryKey: interviewQuestionKey(interviewQuestionId),
    input: {
      questionId: interviewQuestionId,
    },
    convertResponse: (data) => data.question,
  })
}
